[
  {
    "code": "KN-N",
    "name": "Nevis"
  },
  {
    "code": "KN-K",
    "name": "Saint Kitts"
  }
]